var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CrmMobilePullRefreshIndicator',{attrs:{"height-px":_vm.pullVisualPx,"armed":_vm.pullArmed}})
}
var staticRenderFns = []

export { render, staticRenderFns }